import { render } from "./PasswordResetView.vue?vue&type=template&id=56b18c80"
import script from "./PasswordResetView.vue?vue&type=script&lang=js"
export * from "./PasswordResetView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__